module.exports = __webpack_public_path__ + "media/jackpot2.95d312d9.mp3";